import { Empty } from 'antd';
import * as React from 'react';
import { useMemo } from 'react';
import { useTreeReferencesContext } from '../../../../../../../tree/references/TreeReferencesContext';
import { ExpressionReferenceInput } from '../../../../../../expressions/references/input/ExpressionReferenceInput';
import { WidgetType } from '../../../../../Widget';
import { ButtonActionContainer } from '../style/ButtonActionContainer';

export interface IButtonActionSubsectionOpenConfigProps {
  name: string;
}

export function ButtonActionSubsectionOpenConfig(
  props: IButtonActionSubsectionOpenConfigProps,
) {
  const { references, root } = useTreeReferencesContext();

  const componentName = useMemo(() => {
    return `${props.name}.subsectionReference`;
  }, [props.name]);

  if (!root) return null;

  return (
    <ButtonActionContainer name="Apri sottosezione">
      <ExpressionReferenceInput
        width="100%"
        references={references}
        name={componentName}
        config={{
          filter: ref => ref.widgetType === WidgetType.Subsection,
          includeEmpty: true,
        }}
        notFoundContent={
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nessuna sottosezione trovata"
          />
        }
      />
    </ButtonActionContainer>
  );
}
